import type { ApiResponse } from '@/types/api.types';
import { apiClient } from '@lib/axios';

import type { AccountInfo, AuthTokens, GoogleInviteRegisterResponse, GoogleLoginResponse, GoogleRegisterResponse, LoginCredentials, User } from '../types/auth.types';

export async function loginUser(
  credentials: LoginCredentials,
): Promise<ApiResponse<{ user: User; tokens: AuthTokens; accounts: AccountInfo[] }>> {
  const { data } = await apiClient.post<ApiResponse<{ user: User; tokens: AuthTokens; accounts: AccountInfo[] }>>(
    '/auth/login',
    credentials,
  );
  return data;
}

export async function logoutUser(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function refreshTokens(refreshToken: string): Promise<ApiResponse<AuthTokens>> {
  const { data } = await apiClient.post<ApiResponse<AuthTokens>>('/auth/refresh', {
    refreshToken,
  });
  return data;
}

export async function getCurrentUser(): Promise<ApiResponse<User>> {
  const { data } = await apiClient.get<ApiResponse<User>>('/auth/me');
  return data;
}

export async function loginWithGoogle(accessToken: string): Promise<GoogleLoginResponse> {
  const { data } = await apiClient.post<GoogleLoginResponse>('/auth/login/google', { accessToken });
  return data;
}

export async function registerWithGoogle(accessToken: string): Promise<GoogleRegisterResponse> {
  const { data } = await apiClient.post<GoogleRegisterResponse>('/auth/register/account/google', { accessToken });
  return data;
}

export async function registerWithGoogleInvite(
  invitationToken: string,
  googleIdToken: string,
): Promise<GoogleInviteRegisterResponse> {
  const { data } = await apiClient.post<GoogleInviteRegisterResponse>(
    '/auth/register/google',
    { invitationToken, googleIdToken },
  );
  return data;
}
